const RevolvingCreditLineIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7084 18.3335H2.29175C1.95008 18.3335 1.66675 18.0502 1.66675 17.7085C1.66675 17.3668 1.95008 17.0835 2.29175 17.0835H17.7084C18.0501 17.0835 18.3334 17.3668 18.3334 17.7085C18.3334 18.0502 18.0501 18.3335 17.7084 18.3335Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M17.1582 11.4164L11.1332 17.4414C9.9499 18.6248 8.04157 18.6248 6.86657 17.4498L3.0249 13.6081L13.3249 3.30811L17.1666 7.14977C18.3416 8.32477 18.3416 10.2331 17.1582 11.4164Z"
      fill="currentColor"
    />
    <path
      d="M13.3251 3.30847L3.01672 13.6085L2.25838 12.8501C1.08338 11.6751 1.08338 9.7668 2.26672 8.58347L8.29172 2.55847C9.47505 1.37513 11.3834 1.37513 12.5584 2.55013L13.3251 3.30847Z"
      fill="currentColor"
    />
    <path
      d="M10.7418 14.6666L9.61676 15.7916C9.38343 16.0249 9.00843 16.0249 8.7751 15.7916C8.54176 15.5582 8.54176 15.1832 8.7751 14.9499L9.9001 13.8249C10.1334 13.5916 10.5084 13.5916 10.7418 13.8249C10.9751 14.0582 10.9751 14.4332 10.7418 14.6666Z"
      fill="currentColor"
    />
    <path
      d="M14.3916 11.0167L12.15 13.2583C11.9166 13.4917 11.5416 13.4917 11.3083 13.2583C11.075 13.025 11.075 12.65 11.3083 12.4167L13.55 10.175C13.7833 9.94167 14.1583 9.94167 14.3916 10.175C14.6166 10.4083 14.6166 10.7833 14.3916 11.0167Z"
      fill="currentColor"
    />
  </svg>
);

export default RevolvingCreditLineIcon;
